import { render, staticRenderFns } from "./cases.vue?vue&type=template&id=2e19c242&scoped=true&"
import script from "./cases.vue?vue&type=script&lang=js&"
export * from "./cases.vue?vue&type=script&lang=js&"
import style0 from "./cases.vue?vue&type=style&index=0&id=2e19c242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e19c242",
  null
  
)

export default component.exports